/**
 * @author Aydin Cinar
 */

(function(app) {
    app.imageGallery= (function() {
        var initialized = false;

        var selectors = {
            gallerySelector     : '.gallery-selector',
            galleryWay          : '.gallery-way',
            galleryImage        : '.gallery-way img',
            uxrNext             : '.uxr-modal-next',
            uxrPre              : '.uxr-modal-pre'
        };

        var lastId , index = 0 ;

        var init = function() {
            initialized = true;

            app.$objs.gallerySelector   = $(selectors.gallerySelector);
            app.$objs.galleryWay        = $(selectors.galleryWay);
            app.$objs.galleryImage      = $(selectors.galleryImage);
            app.$objs.uxrNext           = $(selectors.uxrNext);
            app.$objs.uxrPre            = $(selectors.uxrPre);

            bind();
        };

        var bind = function() {


            $(window).load(function () {
                galleryInit();
                addGalleryId();
            });

            $(document).on('click', selectors.uxrNext , function(e) {
                e.preventDefault();
                getNextItem();
            });

            $(document).on('click', selectors.uxrPre , function(e) {
                e.preventDefault();
                getPreItem();
            });

            appendNavigate();

        };

        var appendNavigate = function () {

            app.$objs.galleryWay.on('uxropen.uxrModal', function(){

                $('.uxr-modal-container').append('<a class="uxr-modal-pre" href="#"></a>' ); //Previous Button Append To Modal
                $('.uxr-modal-container').append('<a class="uxr-modal-next" href="#"></a>' );//Next Button Append To Modal


                var getId= $(this).attr('data-index');
                index = getId;
            });
        };

        var addGalleryId = function () {

            app.$objs.galleryImage.each(function (i) {
                var id = 'uxr-modal-gallery-' + i;
                $(this).attr('id' , id);
                lastId = i;
            });

            app.$objs.galleryWay.each(function (i) {
                $(this).attr('data-index' , i);
            });
        };

        var galleryInit = function () {

            $(app.$objs.gallerySelector).modal({
                width: '800px',
                height: '600px'
            });

        };


        var getNextItem = function () {
            if(index<lastId) {
                index++;
                var el = '#uxr-modal-gallery-' + index;
                var src = $(el).attr('data-image');
                $('.modal-window').attr('src' , src);
            }
        };

        var getPreItem = function () {
            if(index>0) {
                index--;
                var el = '#uxr-modal-gallery-' + index;
                var src = $(el).attr('data-image');
                $('.modal-window').attr('src' , src);
            }
        };


        var isInitialized = function() {
            return initialized;
        };

        return {
            init:          init,
            isInitialized: isInitialized
        };
    })();

    app.registerInit('imageGallery');
})(engelsizyasam);